import "./login.css";
import styles from "./login.module.css";

import { ReactIcons } from "@kalyzee/kalyzee-ui";
import { MasterUI } from "../../../components/common/MasterUI";
import { MainClockRenderer } from "../../../components/renderers/mainClock";
import { AnimatedBackground } from "../../../components/utils/AnimatedBackground";
import { AuthBlock } from "./AuthBlock";

const LoginPage = () => {
  const renderDateAndTime = () => {
    return (
      <MainClockRenderer
        render={date => {
          let stringDate = date.toLocaleDateString(undefined, {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          });
          stringDate = stringDate.charAt(0).toUpperCase() + stringDate.slice(1);
          const stringTime = date.toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          });
          return (
            <div className={styles.dateTime}>
              <span className={styles.date}>{stringDate}</span>
              <span className={styles.time}>{stringTime}</span>
            </div>
          );
        }}
      />
    )
  };

  return (
    <MasterUI>
      <AnimatedBackground contentClassName={styles.backgroundHome}>
        <div className={styles.headerHome}>
          <ReactIcons.LogoFullAnimated className={styles.logoMain} />
          <span className={styles.logo}>
            KALYZÉE
            <span className={styles.logoMeet}>
              {"Connect"}
            </span>
          </span>
        </div>
        <div className={styles.mainHome}>
          <AuthBlock />
        </div>
        <div className={styles.footerHome}>
          {renderDateAndTime()}
        </div>
      </AnimatedBackground>
    </MasterUI>
  );
};

export default LoginPage;
